import * as React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserGroup,
  faHouse,
  faRankingStar,
  faBookOpen,
  faNewspaper,
  faChartLine,
  faGun,
  faVest
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@reach/router';
import { Nav } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../state/Store';
import { ToggleMenu } from '../../layout/actions/Layout.actions';

export const EndfieldMenu: React.FC = () => {
  const pathFragments = useLocation()
    .pathname.split('/')
    .filter((p) => p && p.trim().length > 0);
  const activeKey = pathFragments.length < 1 ? 'home' : pathFragments[0];

  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (model.layout.isMenuVisible === true) {
      dispatch(ToggleMenu());
    }
  };

  return (
    <Nav className="ms-auto" activeKey={activeKey}>
      <Link to="/arknights-endfield/">
        <Nav.Link as="span" eventKey="home" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHouse} width="18" /> <span>Home</span>
        </Nav.Link>
      </Link>
      <Link to="/arknights-endfield/characters">
        <Nav.Link as="span" eventKey="characters" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserGroup} width="18" />{' '}
          <span>Characters</span>
        </Nav.Link>
      </Link>
      <Link to="/arknights-endfield/characters-stats">
        <Nav.Link as="span" eventKey="characters-stats" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faChartLine} width="18" />{' '}
          <span>Characters Attributes</span>
        </Nav.Link>
      </Link>
      <Link to="/arknights-endfield/tier-list">
        <Nav.Link as="span" eventKey="tier-list" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faRankingStar} width="18" />{' '}
          <span>Tier list</span>
        </Nav.Link>
      </Link>
      <Link to="/arknights-endfield/weapons">
        <Nav.Link as="span" eventKey="weapons" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faGun} width="18" /> <span>Weapons</span>
        </Nav.Link>
      </Link>
      <Link to="/arknights-endfield/gear">
        <Nav.Link as="span" eventKey="gear" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faVest} width="18" /> <span>Gear</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/arknights-endfield/guides/">
        <Nav.Link as="span" eventKey="guides" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBookOpen} width="18" /> <span>Guides</span>
        </Nav.Link>
      </Link>
      <hr />
      <a href="https://blog.prydwen.gg/category/arknights-endfield/">
        <Nav.Link as="span" eventKey="blog">
          <FontAwesomeIcon icon={faNewspaper} width="18" /> <span>Blog</span>
        </Nav.Link>
      </a>
    </Nav>
  );
};
